const Access = () => import('@/views/main/fubo/access/Access.vue')
export default {
  path: '/main/fubo/access',
  name: 'fuboAccess',
  component: Access,
  children: []
}
